import React, { useEffect } from "react";
import '../Styles/components.css';
import './AddCart.css';
import { useCart } from "react-use-cart";
import { MdDelete, MdShoppingCartCheckout } from "react-icons/md";
import PlacePopUp from "../PopUps/PlaceOrder_PopUp/PlacePopUp";

const AddCart = ({ PlaceOrderOpen, ClosePlaceOrder, PlaceOrderModalOpen, open, children, className, ...restProps }) => {
  const {
    isEmpty,
    items,
    totalItems,
    updateItemQuantity,
    removeItem,
    emptyCart,
    setItems,
  } = useCart();
  const incrementTopping = (itemId, topping) => {
    const updatedItems = items.map((item) => {

      if (item.id === itemId) {
        const updatedToppings = item.toppings.map((top) => {
          if (top === topping) {
            // Increment the quantity of the matching topping
            return {
              ...top,
              quantity: top.quantity + 1,
            };
          }
          return top;
        });
        return {
          ...item,
          toppings: updatedToppings,
        };
      }
      return item;
    });
    setItems(updatedItems);
  };

  useEffect(() => {
    // Save items to local storage whenever items change
    localStorage.setItem("cartItems", JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    // Retrieve items from local storage when the component mounts
    const storedItems = localStorage.getItem("cartItems");
    if (storedItems) {
      setItems(JSON.parse(storedItems));
    }
  }, [setItems]);

  const decrementTopping = (itemId, topping) => {
    const updatedItems = items.map((item) => {
      if (item.id === itemId) {
        const updatedToppings = item.toppings.map((top) => {
          if (top === topping) {
            // Decrement the quantity of the matching topping
            const newQuantity = top.quantity - 1;
            if (newQuantity > 0) {
              return {
                ...top,
                quantity: newQuantity,
              };
            }
          }
          return top;
        }).filter(Boolean); // Remove toppings with quantity 0 or less
        return {
          ...item,
          toppings: updatedToppings,
        };
      }
      return item;
    });
    setItems(updatedItems);
  };



  const removeTopping = (itemId, topping) => {
    const updatedItems = items.map((item) => {

      if (item.id === itemId) {

        const updatedToppings = item.toppings.filter((top) => top !== topping);
        return {
          ...item,
          toppings: updatedToppings,

        };
      }
      return item;
    });
    setItems(updatedItems);
    console.log(updatedItems)
  };

  const calculateItemTotal = (item) => {
    const toppingsPrice = item.toppings.reduce(
      (total, topping) => total + topping.price * topping.quantity,
      0
    );
    return (item.price + toppingsPrice) * item.quantity;
  };

  const calculateCartTotal = () => {
    return items.reduce((total, item) => total + calculateItemTotal(item), 0);
  };
  const cartItems = (useCart().items);
  return (
    <>
      <div {...restProps} className={`theme-div AddCart-div ${className}`} open={open}>

        {isEmpty ? (
          <div className="AddCart-empty">
            <p className={`theme-p AddCart-p`} children="Your cart is empty" />

            {/* svg */}
            <svg fill="var(--main-color)" height="155px" width="155px" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round">
              </g><g id="SVGRepo_iconCarrier"> <g> <g>
                <path d="M299.614,118.144C289.382,101.982,272.683,93.892,256,93.892c-16.666,0-33.314,8.055-43.554,24.158 c-10.334,16.239-10.351,37.683-0.051,53.948c20.454,32.307,66.662,32.299,87.159,0.094 C309.888,155.853,309.914,134.409,299.614,118.144z M280.132,153.6H268.8c-2.355,0-4.267,1.911-4.267,4.267v11.341 c0,4.71-3.814,8.533-8.533,8.533s-8.533-3.823-8.533-8.533v-11.341c0-2.355-1.911-4.267-4.267-4.267h-11.332 c-4.719,0-8.533-3.823-8.533-8.533s3.814-8.533,8.533-8.533H243.2c2.355,0,4.267-1.911,4.267-4.267v-11.341 c0-4.71,3.814-8.533,8.533-8.533s8.533,3.823,8.533,8.533v11.341c0,2.355,1.911,4.267,4.267,4.267h11.332 c4.719,0,8.533,3.823,8.533,8.533S284.851,153.6,280.132,153.6z"></path>
              </g> </g> <g> <g> <path d="M329.873,384H268.8c-2.355,0-4.267,1.911-4.267,4.267v42.667c0,2.355,1.911,4.267,4.267,4.267h53.316 c2.065,0,3.831-1.476,4.198-3.507l7.757-42.667C334.549,386.415,332.536,384,329.873,384z"></path>
              </g> </g> <g> <g> <path d="M243.2,384h-61.073c-2.662,0-4.676,2.415-4.198,5.026l7.757,42.667c0.367,2.031,2.133,3.507,4.198,3.507H243.2 c2.355,0,4.267-1.911,4.267-4.267v-42.667C247.467,385.911,245.555,384,243.2,384z"></path> </g> </g> <g> <g> <path d="M155.648,361.907l-6.204-34.133c-0.367-2.031-2.133-3.507-4.198-3.507h-74.53c-2.825,0-4.864,2.688-4.113,5.41 l9.481,34.133c0.512,1.843,2.193,3.123,4.113,3.123h71.253C154.112,366.933,156.126,364.518,155.648,361.907z"></path> </g> </g> <g> <g> <path d="M351.599,264.533H268.8c-2.355,0-4.267,1.911-4.267,4.267v34.133c0,2.355,1.911,4.267,4.267,4.267h76.587 c2.065,0,3.831-1.476,4.198-3.507l6.204-34.133C356.267,266.948,354.261,264.533,351.599,264.533z"></path> </g> </g> <g> <g> <path d="M243.2,264.533h-82.799c-2.662,0-4.676,2.415-4.198,5.026l6.204,34.133c0.375,2.031,2.142,3.507,4.207,3.507H243.2 c2.355,0,4.267-1.911,4.267-4.267V268.8C247.467,266.445,245.555,264.533,243.2,264.533z"></path> </g> </g> <g> <g> <path d="M168.055,430.174l-7.757-42.667c-0.367-2.031-2.133-3.507-4.19-3.507H87.313c-2.825,0-4.872,2.688-4.122,5.41 l10.982,39.543c1.033,3.686,4.395,6.246,8.226,6.246h61.457C166.519,435.2,168.533,432.785,168.055,430.174z"></path> </g> </g> <g> <g> <path d="M340.736,324.267H268.8c-2.355,0-4.267,1.911-4.267,4.267v34.133c0,2.355,1.911,4.267,4.267,4.267h65.732 c2.065,0,3.831-1.476,4.198-3.507l6.204-34.133C345.412,326.682,343.398,324.267,340.736,324.267z"></path> </g> </g> <g> <g> <path d="M424.695,384H355.9c-2.065,0-3.831,1.476-4.198,3.507l-7.757,42.667c-0.478,2.611,1.528,5.026,4.19,5.026H409.6 c3.831,0,7.194-2.551,8.218-6.246L428.8,389.41C429.56,386.688,427.511,384,424.695,384z"></path> </g> </g> <g> <g> <path d="M503.467,76.8h-25.6c-2.85,0-5.521,1.425-7.1,3.797L370.901,230.4H141.099L41.233,80.597 c-1.579-2.372-4.25-3.797-7.1-3.797h-25.6C3.823,76.8,0,80.623,0,85.333s3.823,8.533,8.533,8.533h21.035L120.593,230.4h-86.46 c-4.71,0-8.533,3.823-8.533,8.533v34.133c0,4.71,3.823,8.533,8.533,8.533h19.115l6.246,22.477 c0.512,1.843,2.193,3.123,4.105,3.123h76.988c2.662,0,4.676-2.415,4.198-5.026l-6.204-34.133 c-0.367-2.031-2.133-3.507-4.198-3.507H42.667v-17.067h426.667v17.067h-91.716c-2.065,0-3.831,1.476-4.198,3.507l-6.204,34.133 c-0.478,2.611,1.536,5.026,4.198,5.026h76.988c1.92,0,3.601-1.28,4.113-3.123l6.238-22.477h19.115c4.71,0,8.533-3.823,8.533-8.533 v-34.133c0-4.71-3.823-8.533-8.533-8.533h-86.46l91.025-136.533h21.035c4.71,0,8.533-3.823,8.533-8.533S508.177,76.8,503.467,76.8 z"></path>
              </g> </g> <g> <g> <path d="M243.2,324.267h-71.936c-2.662,0-4.676,2.415-4.198,5.026l6.204,34.133c0.375,2.031,2.142,3.507,4.198,3.507H243.2 c2.355,0,4.267-1.911,4.267-4.267v-34.133C247.467,326.178,245.555,324.267,243.2,324.267z"></path> </g> </g> <g> <g> <path d="M441.284,324.267h-74.53c-2.065,0-3.831,1.476-4.198,3.507l-6.204,34.133c-0.478,2.611,1.536,5.026,4.198,5.026h71.253 c1.92,0,3.601-1.28,4.113-3.123l9.481-34.133C446.148,326.955,444.109,324.267,441.284,324.267z">
              </path> </g> </g> </g></svg>
            <p className={`theme-p AddCart-p-0`} children="Add items to get started" />
          </div>

        ) : (

          <>

            <div className="AddCart-items">
              <div className="heading" >
                <h2>Your Cart</h2>

                <button
                  className="clearbtn"
                  onClick={emptyCart}
                >
                  Clear Cart
                </button>
              </div>
              <div className="AddCart-mainmain">
              {items.map((item) => (
                <div className="AddCart-main" key={item.id}>
                  <div className="AddCart-item" >
                    <div className="Image-container"><img className="AddCart-image" src={item.image} alt='' /></div>
                    <div className="AddCart-itemDetails">
                      <div className="cname-item">
                        <div className="main_name-item">
                          <h4 className="AddCart-itemTitle">{item.name}</h4>
                          <p className="AddCart-optionname">({item.option.name})</p>
                        </div>
                        <div className="item-Total">
                          <p>Rs.{calculateItemTotal(item)}</p>
                        </div>
                      </div>

                      
                      <div className="updateCart">
                        <div className="addsub">
                        <button
                          type="button"
                          className="minus"
                          onClick={() => updateItemQuantity(item.id, item.quantity - 1)}
                        > -
                        </button>

                        {item.quantity}

                        <button
                          type="button"
                          className="plus"
                          onClick={() => updateItemQuantity(item.id, item.quantity + 1)}
                        >+
                        </button>
                        </div>
                        <div className="delete-item cart-product">
                          <button
                            type="button"
                            className="removebtn"
                            onClick={() => removeItem(item.id)}
                          >
                            <MdDelete style={{ width: "16px", marginTop: "4px" }} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {item.toppings.map((selectedTopping) => (
                        <div key={selectedTopping.id}>
                          <div className="topping-main">
                            <p className="AddCart-toppingname">{selectedTopping.name}</p>
                          
                          
                          <div className="updateCart-topping">
                            <button
                              type="button"
                              className="minustop"
                              onClick={() => decrementTopping(item.id, selectedTopping)}
                            >
                              -
                            </button>
                            {selectedTopping.quantity}
                            <button
                              type="button"
                              className="plustop"
                              onClick={() => incrementTopping(item.id, selectedTopping)}
                            >
                              +
                            </button>
                          </div>
                          <div className="delete-topping">
                            <button
                              type="button"
                              className="removebtntop"
                              onClick={() => removeTopping(item.id, selectedTopping)}
                            >
                              <MdDelete style={{marginTop: "5px"}}/>
                            </button>

                          </div>
                          <p className="AddCart-toppingprice">Rs.{selectedTopping.price * selectedTopping.quantity}</p>
                        </div>
                        
                        </div>
                      ))}


                  <p style={{ fontSize: "13px", }}> {item.specialInstructions}</p>

                  <hr className='Divider'></hr>
                </div>
              ))}
             </div> 
            </div>

            <div className="check-out">
              <h2>Total: ({totalItems} items)</h2>
              <h3>Rs.{calculateCartTotal()}</h3>

              <button
                className="orderbtn"
                onClick={() => PlaceOrderOpen(items)}
              >
                Checkout <MdShoppingCartCheckout className="checkouticon" />
              </button>

            </div>

          </>
        )
        }

      </div>
      <PlacePopUp open={PlaceOrderModalOpen} onClose={ClosePlaceOrder} items={cartItems} calculateItemTotal={calculateItemTotal} calculateCartTotal={calculateCartTotal} />
    </>
  )

};

export default AddCart;